import { render, staticRenderFns } from "./activityPromulgate.vue?vue&type=template&id=2b1a5d13&scoped=true"
import script from "./activityPromulgate.vue?vue&type=script&lang=js"
export * from "./activityPromulgate.vue?vue&type=script&lang=js"
import style0 from "./activityPromulgate.vue?vue&type=style&index=0&id=2b1a5d13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a5d13",
  null
  
)

export default component.exports